var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions-container"},_vm._l((_vm.items),function(item){return _c('Item',{key:item.value,attrs:{"item":item},on:{"click":_vm.onClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }